<h3 class="title configurator-title">{{ 'closet-doors.environment.title' | translate }}</h3>
<div class="config-container shadow">
  <h4 class="title configurator-subtitle">{{ 'closet-doors.environment.your-emplacement' | translate }}</h4>
  <div class="location-container">
    <div
      class="location-card"
      [ngClass]="{ active: isEmplacementSelected(emplacement.id) }"
      *ngFor="let emplacement of emplacements"
      (click)="selectEmplacement(emplacement)">
      <img [src]="baseImgURL + emplacement.icon.path" alt="location-img" class="location-img" />
      <p class="location-title" *ngIf="currentLang === 'fr'">{{ emplacement.nameFr }}</p>
      <p class="location-title" *ngIf="currentLang === 'en'">{{ emplacement.nameEn }}</p>
    </div>
    <ng-casto-loader *ngIf="emplacements === undefined"></ng-casto-loader>
  </div>

  <h4 class="title configurator-subtitle">{{ 'closet-doors.environment.drawers' | translate }}</h4>
  <div class="d-flex">
    <span class="mr-2">{{ 'closet-doors.environment.no' | translate }}</span>
    <div class="custom-control custom-switch">
      <input
        type="checkbox"
        [(ngModel)]="hasDrawers"
        class="custom-control-input"
        id="customSwitch2"
        (change)="selectHasDrawers()" />
      <label class="custom-control-label" for="customSwitch2">{{ 'closet-doors.environment.yes' | translate }}</label>
    </div>
  </div>

  <h4 class="title configurator-subtitle mt-4" *ngIf="hasDrawers">
    {{ 'closet-doors.environment.drawers-location' | translate }}
  </h4>
  <p class="custom-form-row form-checkbox" *ngIf="hasDrawers">
    <span>
      <input type="checkbox" id="input-signup-newsletter" [(ngModel)]="drawerLeft" (change)="selectDrawersLocation()" />
      <label for="input-signup-newsletter">{{ 'closet-doors.environment.left' | translate }}</label>
    </span>

    <span>
      <input type="checkbox" id="input-signup-partners" [(ngModel)]="drawerCenter" (change)="selectDrawersLocation()" />
      <label for="input-signup-partners">{{ 'closet-doors.environment.center' | translate }}</label>
    </span>

    <span>
      <input type="checkbox" id="input-signup-contact" [(ngModel)]="drawerRight" (change)="selectDrawersLocation()" />
      <label for="input-signup-contact">{{ 'closet-doors.environment.right' | translate }}</label>
    </span>
  </p>
</div>
